class ConfiguratorSummary extends HTMLElement {
  constructor() {
    super();
    this.container = document.getElementById("summaryBoard");
    this.template = this.querySelector("template");
  }

  static get observedAttributes() {
    return [];
  }

  updateSummaryBlock() {
    //const options = this.getCurrentVariant().text.split(" - ")[0];
    const options = this.getCurrentVariant().text;
    const option1 = options.split(" / ")[0];
    const option2 = options.split(" / ")[1];
    const option3 = options.split(" / ")[2].split(" - ")[0];
    const previewImg = document.getElementById('img__img5');
    const selectedOption1 = document.getElementById('selected-option-1');
    const selectedOption2 = document.getElementById('selected-option-2');
    const selectedOption3 = document.getElementById('selected-option-3');
    const selectedOptionImage = document.getElementById('selected-option-img');
    selectedOption1.innerText = option1;
    selectedOption2.innerText = option2;
    selectedOption3.innerText = option3;
    //selectedOptionImage.src = previewImg.src;
  }

  getCurrentVariant() {
	return document.querySelector('select[name="id"] option:checked');
  }
  _attachEventHandlers() {
	document.querySelector('select[name="id"]').addEventListener("change", function (event) {
		this.updateSummaryBlock();
	}.bind(this));
	// document.querySelector('').addEventListener("click", function (event) {
	// 	this.removeSummaryItem();
	// }.bind(this));
   }

  connectedCallback() {
	  this._render();
  }

  _render() {
	this.container.append(this.template.content);
	this._attachEventHandlers();
  };
}

window.customElements.define("configurator-summary", ConfiguratorSummary);
